import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export var risks = [{
  value: [1, 2],
  name: 'conservative',
  label: 'Conservador',
  shortDescription: 'Buscas protección frente a la inflacción y estabilidad patrimonial.',
  longDescription: 'Admites un riesgo bajo en tu inversión. Tu principal objetivo es preservar el capital y protegerte frente a la inflación, buscando rendimientos bajos y estables en productos de alta liquidez. Los activos financieros que más te encajan son productos de renta fija (tanto deuda gubernamental como deuda corporativa con buena calificación crediticia), depósitos y cuentas de ahorro, aunque puedes dedicar un pequeño porcentaje de tu inversión a productos de renta variable de gran capitalización y probada solvencia y estabilidad.'
}, {
  value: [3, 4, 5],
  name: 'moderate',
  label: 'Moderado',
  shortDescription: 'Buscas equilibrio entre estabilidad y crecimiento patrimonial.',
  longDescription: 'Admites un riesgo intermedio en tu inversión. Tu principal objetivo es conseguir el equilibrio entre estabilidad y crecimiento patrimonial. Tu cartera debería estar formada por una combinación entre productos de renta fija (tanto deuda gubernamental de medio y largo plazo como deuda corporativa), renta variable, acciones preferentes y productos estructurados con un nivel medio de liquidez.'
}, {
  value: [6, 7],
  name: 'aggressive',
  label: 'Arriesgado',
  shortDescription: 'Buscas crecimiento patrimonial asumiendo un nivel de riesgo superior.',
  longDescription: 'Admites un riesgo alto en tu inversión. Buscas maximizar la rentabilidad de tus inversiones ya que tu principal objetivo es el crecimiento patrimonial. Aceptas pérdidas temporales de la valoración de tu cartera como consecuencia de los altos niveles de volatilidad que estás dispuesto a aceptar. La mayor parte de tus inversiones deberán ser activos financieros de renta variable, productos estructurados, opciones, futuros, contratos por diferencia (CFDs) y otros productos derivados. Necesitas un nivel bajo de liquidez.'
}];
export var getSRRIByName = function getSRRIByName(name) {
  var srri = risks.find(function (item) {
    return item.name === name;
  });
  return srri ? srri : null;
};
export var getSRRIByValue = function getSRRIByValue(value) {
  var srri = risks.find(function (item) {
    return item.value.includes(value);
  });
  return srri ? srri : null;
};